import { useQuery } from '@tanstack/react-query';
import { apiAssetsHost } from '../../../utils/ApiService';
import { ApiLocalStorage } from '../../../utils/ApiLocalStorage';
import { handleApiError } from 'components/ErrorHandler';
import routes from 'components/pages/Routes';

export const SCHEMA_STORAGE_KEY = 'account_schema';

interface AccountSchemaResponse {
    [key: string]: ThemeData;
}

interface ThemeData {
    logo?: string;
    background?: string;
    [key: string]: any;
}

export const useGetAccountSchema = () => useQuery(
    ['getAccountSchema'],
    async () => {
        const cachedData = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
        
        try {
            const fetchPromise = apiAssetsHost.get<AccountSchemaResponse>('/account/schema.json')
                .then(response => {
                    const rawData = response.data || response;
                    
                    // Preservar campos de configuração do schema
                    const configFields = ['id', 'tenantId', 'signupType', 'authenticationType', 'otpRequestChannelTypes', 'createdDate', 'updatedDate'];
                    
                    // Remove apenas seções que são realmente vazias (formFields vazios ou option 'None')
                    // mas preserva campos de configuração
                    const cleanData = Object.fromEntries(
                        Object.entries(rawData).filter(([key, value]) => {
                            // Sempre preservar campos de configuração
                            if (configFields.includes(key)) {
                                return true;
                            }
                            
                            // Para outros campos, verificar se são seções vazias
                            if (typeof value === 'object' && value !== null) {
                                return !(
                                    (value.formFields && value.formFields.length === 0) || 
                                    value.option === 'None'
                                );
                            }
                            
                            // Preservar outros tipos de valores
                            return true;
                        })
                    );

                    ApiLocalStorage.set(SCHEMA_STORAGE_KEY, cleanData);
                    
                    return cleanData;
                })
                .catch((error) => {
                    window.location.hash = routes.construction.path;
                    handleApiError(error, 'Erro ao carregar schema');
                    
                    return cachedData || {};
                });

            return cachedData ? Promise.resolve(cachedData) : fetchPromise;
        } catch (error) {
            window.location.hash = routes.construction.path;
            handleApiError(error, 'Erro ao carregar schema');
            
            return cachedData || {};
        }
    },
    {
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    }
); 
